import React, { useContext, useEffect, useState } from "react";
import { Layout, List, Table, Button, Image, Modal, Input } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import "../styleCss.scss";
import apiJurados from '../../../../api/Jurados/api-jurados'
import EscudoAlcaldiaBlanco from "../../../../assets/landing/medellin.png";



import EvaluaarProyectoFormNotaModel from "./EvaluaarProyectoFormNotaModel";
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import apiNotificaciones from "../../../../api/Notificaciones/api-notificaciones";
import { TemplateContext } from "../../../../utils/template_context";
import jsPDF from 'jspdf';
import { PDF_PW, PDF_PH, PDF_MG, PDF_CW, PDF_LABEL_W } from '../../../../utils/pdfPage';


const getJurado = async (data: any) => {
  const response = await apiJurados.obtenerCriterioJurado(data)
  return response;
}
export const EvaluacionProyectosModel = (props: any) => {
  useEffect(() => {
    if (props.jurado?.id_jurado) {
      getJurado(props.jurado.id_jurado)
    }
  }, [props.jurado?.id_jurado])

  const [tableShow, setTableShow] = useState<any>("documentosTecnicos");
  const [evalProyectoPage, setEvalProyectoPage] = useState<any>("informacionProyectosList");
  const [documentOpen] = useState<any>(false);
  const [modalVisualizarDocumento, setModalVisualizarDocumento] = useState(false);
  const [documentoVisualizar, setDocumentoVisualizar] = useState("")
  const [openModalEscritoVideo, setOpenModalEscritoVideo] = useState(false);
  const [datosEscritoVideo, setDatosEscritoVideo] = useState<any>({});
  const context = useContext(TemplateContext);

  const columns: any = [
    {
      title: <span className="as_tbl_hd">Nombre documento</span>,
      width: 500,
      dataIndex: "tipo_documento",
      key: "tipo_documento",
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Acciones</span>,
      key: "acciones",
      fixed: context.device === "lg" ? "right" : false,
      width: 120,
      render: (datos: any) => (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <button type="button" className="view_detl"
            onClick={() => {
              if (datos.tipo_documento === "Escrito y Video") {
                setDatosEscritoVideo(datos);
                setOpenModalEscritoVideo(true);
              } else {
                setModalVisualizarDocumento(true);
                setDocumentoVisualizar(datos.url_participante);
              }
            }}
          >
            Ver Más
          </button>
        </div>
      ),
    },
  ];

  const enlacesdivumns: any = [
    {
      render: (datos: any) => (
        <span>
          <a href={datos.url} target="_blank">{datos.url}</a>
        </span>
      )
    },
  ];

  const numerosEnPalabras: string[] = [
    'Cero', 'Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve',
    'Diez', 'Once', 'Doce', 'Trece', 'Catorce', 'Quince', 'Dieciséis', 'Diecisiete', 'Dieciocho', 'Diecinueve',
    'Veinte', 'Veintiuno', 'Veintidós', 'Veintitrés', 'Veinticuatro', 'Veinticinco', 'Veintiséis', 'Veintisiete', 'Veintiocho', 'Veintinueve',
    'Treinta', 'Treinta y uno', 'Treinta y dos', 'Treinta y tres', 'Treinta y cuatro', 'Treinta y cinco', 'Treinta y seis', 'Treinta y siete', 'Treinta y ocho', 'Treinta y nueve',
    'Cuarenta', 'Cuarenta y uno', 'Cuarenta y dos', 'Cuarenta y tres', 'Cuarenta y cuatro', 'Cuarenta y cinco', 'Cuarenta y seis', 'Cuarenta y siete', 'Cuarenta y ocho', 'Cuarenta y nueve',
    'Cincuenta', 'Cincuenta y uno', 'Cincuenta y dos', 'Cincuenta y tres', 'Cincuenta y cuatro', 'Cincuenta y cinco', 'Cincuenta y seis', 'Cincuenta y siete', 'Cincuenta y ocho', 'Cincuenta y nueve',
    'Sesenta', 'Sesenta y uno', 'Sesenta y dos', 'Sesenta y tres', 'Sesenta y cuatro', 'Sesenta y cinco', 'Sesenta y seis', 'Sesenta y siete', 'Sesenta y ocho', 'Sesenta y nueve',
    'Setenta', 'Setenta y uno', 'Setenta y dos', 'Setenta y tres', 'Setenta y cuatro', 'Setenta y cinco', 'Setenta y seis', 'Setenta y siete', 'Setenta y ocho', 'Setenta y nueve',
    'Ochenta', 'Ochenta y uno', 'Ochenta y dos', 'Ochenta y tres', 'Ochenta y cuatro', 'Ochenta y cinco', 'Ochenta y seis', 'Ochenta y siete', 'Ochenta y ocho', 'Ochenta y nueve',
    'Noventa', 'Noventa y uno', 'Noventa y dos', 'Noventa y tres', 'Noventa y cuatro', 'Noventa y cinco', 'Noventa y seis', 'Noventa y siete', 'Noventa y ocho', 'Noventa y nueve', 'Cien'
  ];

  const obtenerLetras = (num: number) => {
    if (num >= 0 && num <= 100) {
      return numerosEnPalabras[num];
    } else {
      return 'Sin dato';
    }
  }


  const imprimir = async () => {
    const proyecto = props.proyectosJurado.proyecto;
    const criteriosList: any[] = [...(props.proyectosJurado.criterios || [])].sort((a, b) => a.id - b.id);

    const PW = PDF_PW, MG = PDF_MG, CW = PDF_CW;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const str = (v: any) => (v == null ? '' : String(v));

    const checkPage = (yy: number, needed: number): number => {
      if (yy + needed > PDF_PH - MG) { pdf.addPage(); return MG; }
      return yy;
    };

    // Logo
    let logoBase64 = '';
    try {
      const src = EscudoAlcaldiaBlanco as unknown as string;
      if (src.startsWith('data:')) {
        logoBase64 = src;
      } else {
        const blob = await fetch(src).then(r => r.blob());
        logoBase64 = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      }
    } catch { /* logo no disponible */ }

    let y = MG;

    // Cabecera
    const HEADER_H = 22;
    pdf.setFillColor(240, 240, 240);
    pdf.rect(MG, y, CW, HEADER_H, 'F');
    if (logoBase64) {
      try {
        const fmt = logoBase64.startsWith('data:image/jpe') ? 'JPEG' : 'PNG';
        pdf.addImage(logoBase64, fmt, MG + 2, y + 2, 18, 12);
      } catch { /* logo no disponible */ }
    }
    pdf.setTextColor(0, 0, 0);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(10);
    pdf.text('SECRETARÍA DE CULTURA CIUDADANA', PW / 2, y + 9, { align: 'center' });
    pdf.setFont('helvetica', 'normal');
    pdf.setFontSize(8);
    pdf.text('CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA', PW / 2, y + 16, { align: 'center' });
    y += HEADER_H + 6;

    // Campos del proyecto
    const LBL_W = PDF_LABEL_W;
    const VAL_X = MG + LBL_W + 4;
    const VAL_W = CW - LBL_W - 4;
    const LH = 4.5;
    const ROW_PAD = 2;

    const campos = [
      { label: 'Código del proyecto', value: str(proyecto.radicado) },
      { label: 'Línea', value: str(proyecto.linea_convocatoria) },
      { label: 'Nombre del proyecto', value: str(proyecto.nombre_propuesta) },
      { label: 'Categoría', value: str(proyecto.categoria_linea_convocatoria) },
    ];

    pdf.setFontSize(9);
    for (const campo of campos) {
      pdf.setFont('helvetica', 'bold');
      const lblLines = pdf.splitTextToSize(campo.label + ':', LBL_W);
      pdf.setFont('helvetica', 'normal');
      const valLines = pdf.splitTextToSize(campo.value, VAL_W);
      const rowH = Math.max(lblLines.length, valLines.length) * LH + ROW_PAD * 2;
      const textY = y + ROW_PAD + LH * 0.8;
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(80, 80, 80);
      pdf.text(lblLines, MG, textY);
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(0, 0, 0);
      pdf.text(valLines, VAL_X, textY);
      y += rowH;
    }

    y += 4;

    // Título criterios
    y = checkPage(y, 10);
    pdf.setFont('helvetica', 'bold');
    pdf.setFontSize(10);
    pdf.setTextColor(0, 0, 0);
    pdf.text('Criterios de evaluación', MG, y);
    y += 6;

    // Filas de criterios
    const COL_NOTA = 18;
    const COL_CONTENT = CW - COL_NOTA - 2;
    const LINE_H = 3.8;
    const MIN_ROW_H = 5;
    const PAD_V = 1;

    pdf.setFontSize(8.5);
    criteriosList.forEach((c: any, idx: number) => {
      pdf.setFont('helvetica', 'bold');
      const nombreLines = pdf.splitTextToSize(str(c.nombre), COL_CONTENT - 4);
      pdf.setFont('helvetica', 'normal');
      const obsLines = pdf.splitTextToSize(str(c.observaciones), COL_CONTENT - 4);
      const rowH = Math.max(MIN_ROW_H, PAD_V + nombreLines.length * LINE_H + obsLines.length * LINE_H + PAD_V);

      y = checkPage(y, rowH);
      const bg = idx % 2 === 0 ? 240 : 255;
      pdf.setFillColor(bg, bg, bg);
      pdf.rect(MG, y, CW, rowH, 'F');

      let textY = y + PAD_V + LINE_H * 0.8;
      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text(nombreLines, MG + 2, textY);
      textY += nombreLines.length * LINE_H;
      pdf.setFont('helvetica', 'normal');
      pdf.setTextColor(60, 60, 60);
      pdf.text(obsLines, MG + 2, textY);

      pdf.setFont('helvetica', 'bold');
      pdf.setTextColor(0, 0, 0);
      pdf.text(str(c.nota ?? ''), PW - MG - 2, y + rowH / 2 + 1.5, { align: 'right' });
      y += rowH;
    });

    // Puntaje total
    y += 2;
    const boxH = 15;
    y = checkPage(y, boxH);
    pdf.setFillColor(254, 244, 222);
    pdf.rect(MG, y, CW, boxH, 'F');
    pdf.setFontSize(9);
    pdf.setTextColor(0, 0, 0);
    pdf.setFont('helvetica', 'normal');
    pdf.text('Puntaje total:', MG + 3, y + 5);
    pdf.setFont('helvetica', 'bold');
    pdf.text(str(proyecto.nota_final ?? ''), PW - MG - 2, y + 5, { align: 'right' });
    pdf.setFont('helvetica', 'normal');
    pdf.text('Puntaje total en letras: ', MG + 3, y + 11);
    pdf.setFont('helvetica', 'bold');
    pdf.text(obtenerLetras(proyecto.nota_final), MG + 3 + pdf.getTextWidth('Puntaje total en letras: '), y + 11);

    pdf.save(`Evaluacion_${str(proyecto.radicado)}.pdf`);
  }



  return (
    <div id="modal_custom">
      {documentOpen ? (
        <Layout style={{ borderRadius: 15 }}>
        </Layout>
      ) : (
        <div>
          {evalProyectoPage === "informacionProyectosList" && (
            <div>
              <div className="container-fluid" style={{ background: "white", borderRadius: "15px" }}>
                <Content className="model__header">
                  <Content className="mdl_header_containt">
                    <div className="mdl_heading_row">
                      <div className="col-12">
                        <div className="evel_mdl_title font-size-14px pt-2 pb-2 title_modal_morado">
                          Evaluación de Proyecto
                        </div>
                      </div>
                    </div>
                  </Content>
                </Content>
                <Content className="row evalu__top_mdl_box">
                  <Content
                    className="col-12 evalu_inform_header"
                    style={{ background: "#AE3E97" }}
                  >
                    <ul
                      className="menu_tab"
                      style={{ listStyle: "none", display: "flex", margin: "unset" }}
                    >
                      <li
                        className={evalProyectoPage == "informacionProyectosList" ? "active2" : ""}
                      >
                        <button
                          type="button"
                          onClick={() => setEvalProyectoPage("informacionProyectosList")}
                        >
                          Información del proyecto
                        </button>
                      </li>
                      {props.proyectosJurado.proyecto.estado == 'Por evaluar' &&
                        <li
                          className={evalProyectoPage == "evaluaarProyectoForm" ? "active2" : ""}
                        >
                          <button
                            type="button"
                            onClick={() => setEvalProyectoPage("evaluaarProyectoForm")}
                          >
                            Evaluar proyecto
                          </button>
                        </li>
                      }
                    </ul>
                  </Content>

                  <Content
                    className="col-12 evalu_inform_list mb-2"
                    style={{ marginTop: 15, padding: "5px 20px 20px 20px" }}
                  >
                    <div className="row">
                      <Image src={EscudoAlcaldiaBlanco} style={{ maxWidth: "20%" }} preview={false} />
                      <br />
                      <br />
                      <span className="md-title-text text-center">
                        <br />
                        SECRETARÍA DE CULTURA CIUDADANA
                      </span>
                      <br />
                      <span className="md-title-text text-center">
                        CONVOCATORIA DE FOMENTO Y ESTÍMULOS PARA EL ARTE Y LA CULTURA
                      </span>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Código del proyecto:</span>
                            </Content>
                            <hr />
                          </div>
                          <div className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box">
                              {" "}
                              <span className="inform_value font-family-Montserrat-Regular" style={{ fontWeight: 'bold' }}>{props.proyectosJurado.proyecto.radicado} </span>
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Línea:</span>
                            </Content>
                            <hr />
                          </div>
                          <div className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box">
                              {" "}
                              <span className="inform_value font-family-Montserrat-Regular" style={{ fontWeight: 'bold' }}>
                                {props.proyectosJurado?.proyecto.linea_convocatoria}
                              </span>
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Nombre del proyecto:</span>
                            </Content>
                            <hr />
                          </div>
                          <div className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box">
                              {" "}
                              <span className="inform_value font-family-Montserrat-Regular" style={{ fontWeight: 'bold' }}>{props.proyectosJurado.proyecto.nombre_propuesta}</span>
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="row">
                          <div className="col-12 col-md-6 col-lg-4 text-right inform--col">
                            <Content className="inform--col-box d-flex justify-content-md-end">
                              {" "}
                              <span className="inform_title">Categorías:</span>
                            </Content>
                            <hr />
                          </div>
                          <div className="col-12 col-md-6 col-lg-8 inform--col">
                            <Content className="inform--col-box font-family-Montserrat-Regular" style={{ fontWeight: 'bold' }}>
                              {" "}
                              {props.proyectosJurado.proyecto.categoria_linea_convocatoria}
                            </Content>
                            <hr />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Content>
                </Content>
              </div>

              <div className="container-fluid" style={{ marginTop: "10px", background: "white", padding: 20, borderRadius: "15px" }}>
                <Content className="category_mdl_box">
                  <Content className="category_head">
                    <span className="col-12 md-title-text">
                      Criterios de evaluación
                    </span>
                  </Content>
                  <Content className="cat_listing">
                    <hr />
                    <List
                      style={{ paddingTop: "5px", paddingBottom: "5px", }}
                      itemLayout="horizontal"
                      dataSource={props.proyectosJurado.criterios}
                      footer={
                        <div>
                          <List.Item style={{ background: '#faad1424' }}>
                            <List.Item.Meta
                              className="list_cat"
                              title={<span className="cat_list_title font-family-Montserrat-Regular" style={{ padding: "10px" }}>Puntaje total:</span>}
                              description={<span className="cat_list_title font-family-Montserrat-Regular" style={{ padding: "10px" }}>Puntaje total en letras: <span style={{ fontWeight: 'bold' }}>{obtenerLetras(props.proyectosJurado.proyecto.nota_final)}</span></span>}
                            />
                            <div style={{ padding: "10px", fontWeight: 'bold', color: "orange" }}>{props.proyectosJurado.proyecto.nota_final}</div>
                          </List.Item>
                        </div>
                      }
                      renderItem={(item: any, index: number) => (
                        <List.Item style={{ background: index % 2 === 0 ? '#f0f0f0' : 'white' }}>
                          <List.Item.Meta
                            className="list_cat"
                            title={<span className="cat_list_title font-family-Montserrat-Regular">{item.nombre}</span>}
                            description={<span className="cat_list_title font-family-Montserrat-Regular" style={{ fontWeight: 'bold' }}>{item.observaciones}</span>}
                          />
                          <div style={{ padding: "10px", fontWeight: 'bold' }}>{item.nota}</div>
                        </List.Item>
                      )}
                    />
                  </Content>
                </Content>
              </div>

              <div style={{ marginTop: "10px", background: "white", borderRadius: "15px" }}>
                <Content className="evalu_mdl_box" style={{ borderRadius: "15px" }}>
                  <Content
                    className="evalu_head"
                    style={{
                      background: "#AE3E97",
                      display: "flex",
                      width: "100%",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "15px",
                    }}
                  >
                    <Content
                      className="evalu_inform_header"
                      style={{ background: "#AE3E97", display: "flex", width: "100%", borderRadius: '15px' }}
                    >
                      <ul
                        className="evalu_inform_menu evalu_info"
                        style={{
                          listStyle: "none",
                          background: "#AE3E97",
                          display: "flex",
                          alignItems: "center",
                          margin: "unset",
                          borderRadius: '15px',
                        }}
                      >
                        <li
                          className={tableShow === "documentosTecnicos" ? "enabled_tab" : "disabled_tab"}
                        >
                          <button
                            type="button"
                            onClick={() => setTableShow("documentosTecnicos")}
                          >
                            Documentos técnicos del proyecto
                          </button>
                        </li>
                        <li
                          className={tableShow === "enlacesProyecto" ? "enabled_tab" : "disabled_tab"}
                        >
                          <button
                            type="button"
                            onClick={() => setTableShow("enlacesProyecto")}
                          >
                            Enlaces del proyecto
                          </button>
                        </li>
                      </ul>
                    </Content>
                  </Content>
                  <Content className="evalu_listing" style={{ padding: "5px 20px" }}>
                    {tableShow === "documentosTecnicos" ? (
                      <Table
                        columns={columns}
                        dataSource={props.proyectosJurado.proyecto.documentos_tecnicos}
                        scroll={{ x: 900 }}
                        pagination={false}
                        rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                      />
                    ) : (
                      <Table
                        columns={enlacesdivumns}
                        dataSource={props.proyectosJurado.proyecto.links}
                        scroll={{ x: 1000 }}
                        pagination={false}
                        rowClassName={(record, index) => (index % 2 === 0 ? "table-row-dark" : "table-row-light")}
                      />
                    )}
                  </Content>
                  {props.proyectosJurado.proyecto.nota_final == null &&
                    <Content className="container-fluid">
                      <Content
                        style={{
                          height: "20px",
                          display: "flex",
                          justifyContent: "end",
                          marginTop: "10px",
                          marginBottom: "20px",
                        }}
                      >
                      </Content>
                    </Content>
                  }
                  <hr className="m-0" />
                </Content>

                <Content className="mb-2" style={{ padding: 20 }}>
                  <div className="container-fluid">
                    <div className="form--btm-btn-box d-flex justify-content-center" style={{ gap: 8 }}>
                      <Button className="form_bg_btn button-blanco-radius m-0"
                        onClick={imprimir} style={{ border: "none" }}>
                        IMPRIMIR
                      </Button>
                    </div>
                    <div className="form--btm-btn-box d-flex justify-content-end">
                      {props.isTerm &&
                        <Button
                          onClick={async () => {
                            try {
                              let payloadNotificacionAdmin = {
                                nombre_jurado: `${props.jurado.primer_nombre} ${props.jurado.segundo_nombre} ${props.jurado.primer_apellido} ${props.jurado.segundo_apellido}`,
                                tipo_notificacion: "Inhabilita",
                                remitente: props.jurado.numero_documento,
                              }

                              await apiNotificaciones.enviarNotificacionAdministrador(payloadNotificacionAdmin);

                              await apiJurados.desahabilitarProject(props.jurado.id_jurado, props.proyectosJurado.proyecto.id_postulacion);
                              props.setVisible(false);
                              props.consultarProyectoJuradoCriterioProyecto();
                            } catch (error) {
                              console.log(error)
                            }

                          }}
                          className="form_bg_btn font-family-Montserrat-SemiBold"
                          type="primary"
                        >
                          INHABILITAR PROYECTO
                        </Button>
                      }
                      <Button className="form_bg_btn button-blanco-radius m-0"
                        onClick={() => {
                          props.setVisible(false);
                          props.setIsTerm(false)
                        }} style={{ border: "none" }}>
                        CERRAR
                      </Button>
                    </div>
                  </div>
                </Content>
              </div>
            </div>
          )}
          {evalProyectoPage === "evaluaarProyectoForm" && (
            <EvaluaarProyectoFormNotaModel
              evalProyectoPage={evalProyectoPage}
              setEvalProyectoPage={setEvalProyectoPage}
              jurado={props.proyectosJurado}
              isTerm={props.isTerm}
              setVisible={props.setVisible}
              consultarProyectoJuradoCriterioProyecto={props.consultarProyectoJuradoCriterioProyecto}
            />
          )}

          {modalVisualizarDocumento &&
            <ModalVisualizarDocumentos
              visualizar={modalVisualizarDocumento}
              setVisualizar={setModalVisualizarDocumento}
              state={{ documento: documentoVisualizar }}
            />}

          <Modal
            title={
              <div className="font-family-Montserrat-Bold font-size-22px color-0050A0 d-flex align-items-center">
                <EyeOutlined style={{ marginRight: '12px', fontSize: '26px' }} />
                Visualizar Escrito y Video
              </div>
            }
            visible={openModalEscritoVideo}
            onCancel={() => setOpenModalEscritoVideo(false)}
            width={900}
            centered
            footer={[
              <Button
                key="close"
                onClick={() => setOpenModalEscritoVideo(false)}
                className="button-blanco-radius"
              >
                Cerrar
              </Button>
            ]}
          >
            <div className="p-3">
              <div className="mb-4">
                <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
                  Escrito o Narración de la Propuesta:
                </span>
                <Input.TextArea
                  rows={12}
                  value={datosEscritoVideo?.escrito}
                  disabled
                  className="mt-1 font-family-Montserrat-Regular"
                  style={{ borderRadius: '8px', padding: '12px', border: '1px solid #d9d9d9', color: 'rgba(0, 0, 0, 0.85)', backgroundColor: '#f5f5f5' }}
                />
              </div>
              <div className="mt-5">
                <span className="font-family-Montserrat-SemiBold font-size-16px mb-2 d-block color-707070">
                  URL del video de soporte:
                </span>
                <div className="mt-1 p-3" style={{ border: '1px solid #d9d9d9', borderRadius: '8px', backgroundColor: '#f5f5f5' }}>
                  <a
                    href={datosEscritoVideo?.url_video}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-family-Montserrat-Regular"
                    style={{ color: '#0050A0', textDecoration: 'underline' }}
                  >
                    {datosEscritoVideo?.url_video}
                  </a>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </div>
  );
};
